// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","634":"2c796e83"}[chunkId] || chunkId) + "." + {"230":"2d7f52ac34c33d64","281":"666d26f8e6afb630","296":"ed4bfd3b43e98490","380":"2ac2c3daaf339d79","583":"2422ab9546a09aff","634":"ab8c75ba5a2d64ec"}[chunkId] + ".js";
};